import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '@material-ui/core';
import './ProfileMenu.scss';

class ProfileMenu extends Component {
  render() {
    const { currentUser, isShown, triangleLocation } = this.props;
    const photoURL = currentUser ? currentUser.picture : '';
    const uid = currentUser ? currentUser.uid : '';
    if (!isShown) return null;

    return (
      <div className="profile-menu">
        <div style={{ marginLeft: triangleLocation }} className="triangle">
          <div className="triangle-inner" />
        </div>
        <div className="avatar-and-name">
          <div style={{ margin: 'auto', width: 57 }}>
            <Link style={{ cursor: 'pointer' }} to={`/profile/${uid}/shoutouts`}>
              <Avatar className="user-icon profile-icon" alt="profile-menu" src={photoURL} />
            </Link>
          </div>
          <Link style={{ cursor: 'pointer' }} to={`/profile/${uid}/shoutouts`}>
            {currentUser && <div className="profile-menu-name">{currentUser.name}</div>}
          </Link>
          {currentUser && currentUser.unread !== 0 &&
            <div className="new-shoutouts">
              <Link style={{ cursor: 'pointer' }} to={`/profile/${uid}/shoutouts`}>
                <span>{currentUser.unread} new shoutout</span>{currentUser.unread !== 1 && <span>s</span>}!
              </Link>
            </div>
          }
        </div>

        <div className="profile-menu-shoutouts">
          {currentUser &&
            <div>
              <div className="shoutouts-header">Shoutouts:</div>
              <div className="given-and-received">
                <span className="score">{currentUser.shoutoutsReceived}</span> Received
              </div>
              <div className="given-and-received">
                <span className="score">{currentUser.shoutoutsSent}</span> Given
              </div>
            </div>
          }
        </div>
        <div className="profile-menu-footer">
          <Link className="linker" to={`/profile/${uid}/shoutouts`}>
            <div className="profile-footer-text">View Profile</div>
          </Link>
          {(currentUser.role === 'admin' || currentUser.role === 'super_admin') &&
            <div className="profile-footer-text" style={{ marginBottom: 10 }} onClick={() => this.props.adminTools()}>
              <span>Admin Tools</span>
            </div>
          }
          <div className="profile-footer-text" onClick={() => this.props.signOut()}>
            <span>Log Out</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ProfileMenu;


// WEBPACK FOOTER //
// ./src/screens/dashboard/ProfileMenu.js